import { render, staticRenderFns } from "./educationClassDashbord.vue?vue&type=template&id=6561113a&"
import script from "./educationClassDashbord.vue?vue&type=script&lang=js&"
export * from "./educationClassDashbord.vue?vue&type=script&lang=js&"
import style0 from "./educationClassDashbord.vue?vue&type=style&index=0&id=6561113a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports